/**
 * Auth Token Utility
 * Manages JWT access token storage and retrieval
 */

export const STORAGE_KEY_TOKEN = 'charti_access_token';

export const getAccessToken = (): string | null => {
  return localStorage.getItem(STORAGE_KEY_TOKEN);
};

const STORAGE_KEY_SIGNED_IN_BEFORE = 'charti_signed_in_before';

export const setAccessToken = (token: string): void => {
  localStorage.setItem(STORAGE_KEY_TOKEN, token);
  localStorage.setItem(STORAGE_KEY_SIGNED_IN_BEFORE, '1');
};

/** True once anyone has signed in from this browser. It outlives logging out. */
export const hasSignedInHere = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY_SIGNED_IN_BEFORE) === '1';
  } catch {
    return false;
  }
};

export const clearAccessToken = (): void => {
  localStorage.removeItem(STORAGE_KEY_TOKEN);
};

/**
 * True when the token's own expiry has passed, or it cannot be read. Only for
 * deciding what to show; the API remains the judge of whether it is valid.
 */
export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(payload)) as { exp?: number };
    return typeof exp === 'number' && exp * 1000 <= Date.now();
  } catch {
    return true;
  }
};
